import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./drop-down-button.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./drop-down-button.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
let DropDownButtonComponent = class DropDownButtonComponent {
    changeDetectorRef;
    parentContainer;
    options = [];
    btnLabel;
    valueSelected = new EventEmitter();
    buttonClass = "primary";
    dropDownContentVisible = false;
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
    }
    ngOnInit() {
        this.setDropDownButtonContentWidth();
    }
    toggleDropdownContent() {
        this.dropDownContentVisible = !this.dropDownContentVisible;
    }
    emitSelection(event, selection) {
        event.stopPropagation();
        if (selection.enabled === true) {
            const value = selection.value;
            this.dropDownContentVisible = false;
            this.valueSelected.emit(value);
        }
    }
    setDropDownButtonContentWidth() {
        const buttonWidth = document.getElementById("dropDownButton").clientWidth;
        document.getElementById("dropDownButtonContent").style.width = buttonWidth + 59 + "px";
    }
    onControlLoseFocus(event) {
        event.stopPropagation();
        const relatedTarget = event.relatedTarget;
        if (!this.parentContainer.nativeElement.contains(relatedTarget)) {
            console.log("Focus left the entire group");
            this.dropDownContentVisible = false;
            this.changeDetectorRef.detectChanges();
        }
    }
    static ctorParameters = () => [
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        parentContainer: [{ type: ViewChild, args: ["dropdownButtonParentContainer",] }],
        options: [{ type: Input }],
        btnLabel: [{ type: Input }],
        valueSelected: [{ type: Output }],
        buttonClass: [{ type: Input }]
    };
};
DropDownButtonComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-drop-down-button",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], DropDownButtonComponent);
export { DropDownButtonComponent };
